/**
 * Dev-only render counters (the `bumpRender` pattern from the QuickPlay lab).
 *
 * The §6a acceptance is stated in renders per opponent move — Board 1, active
 * Clock 1, MoveList 1, Captured <= 1, everything else 0 — so every component
 * that could break the isolation calls `bump()` at the top of its body and the
 * design lab reads the totals out of `window.__v2Renders`.
 *
 * Costs nothing in production: `__DEV__` is compile-time in the web bundle.
 */
declare const __DEV__: boolean;

export type RenderCounts = {[name: string]: number};

const counts: RenderCounts = {};

const expose = (): void => {
  const w: any = globalThis;
  if (w && !w.__v2Renders) {
    w.__v2Renders = counts;
  }
};

export function bump(name: string): void {
  if (typeof __DEV__ !== 'undefined' && !__DEV__) {
    return;
  }
  counts[name] = (counts[name] || 0) + 1;
  expose();
}

export function readRenderCounts(): RenderCounts {
  return {...counts};
}

export function resetRenderCounts(): void {
  Object.keys(counts).forEach(key => {
    delete counts[key];
  });
}
